// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import CorporateHeroImg from "../../asset/Accounting.png";      // Hero background image
// import CorporateCenterImg from "../../asset/image1.png";        // Center image for Corporate Governance
// import CorporateRightImg from "../../asset/image7.png";         // Right-side image for services section
// import LineImg from "../../asset/line1.png";                    // Line image
// import pointImg from "../../asset/point.png";                   // Icon for points
// import "./ServiceBusiness.css";                   // Create or reuse existing CSS

// const ServiceCorporate = () => {
//   return (
//     <div>
//       {/* Hero Section */}
//       <div
//         className="services-hero"
//         style={{
//           backgroundImage: `url(${CorporateHeroImg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "88vh",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//         }}
//       >
//         {/* Dark Overlay */}
//         <div className="services-overlay"></div>
      
//         {/* Hero Content */}
//         <div className="services-content">
//           <h1 className="services-heading">Building Trust Through Transparency</h1>
//           <p className="services-paragraph">
//             We deliver through audits and assurance services that enhance credibility,
//             accuracy and confidence for your stakeholders.
//           </p>
//         </div>
//       </div>


//       {/* Corporate Governance Image Section */}
//       <div className="detail-section">
//         <Container className="text-center">
//           <div className="d-flex align-items-center justify-content-center flex-wrap">
//             <img src={LineImg} alt="line-left" className="side-line" />

//             <div className="center-image-wrapper">
//               {/* <img
//                 src={CorporateCenterImg}
//                 alt="Corporate Governance Services"
//                 className="side-image"
//               /> */}
//               <div className="corporate-image-text">Corporate Governance & Secretarial practice</div>
//             </div>

//             <img src={LineImg} alt="line-right" className="side-line mirrored" />
//           </div>
//         </Container>
//       </div>

//       {/* Service Points Section */}
//       <div className="service-image-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Column with Points */}
//             <Col md={6}>
//               <ul className="service-points">
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Company/LLP/Partnership Formation
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Conversion of Firms to Companies
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Consultancy on Company Law Matters
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Mergers,Acquisitions & Corporate Restructuring
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Annual ROC/MCA Compliances
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   RBI & FEMA Compliances
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Representation before Register of Companies
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Directors Report, Notice & Minutes
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Public/Bonus/Right Issue Advisory
//                 </li>
                
//               </ul>
//             </Col>

//             {/* Right Column with Image */}
//             <Col md={6} className="text-center text-md-end">
//               <img
//                 src={CorporateRightImg}
//                 alt="Corporate Governance Detail"
//                 className="service-right-image"
//               />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default ServiceCorporate;


import React, { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import CorporateRightImg from "../../asset/corporate.webp";  // Right-side image
import LineImg from "../../asset/line1.png";           // Decorative line
import corporateImg from "../../asset/Accounting.webp";
import pointImg from "../../asset/point.png";          // Icon for points
import "./ServiceBusiness.css";

// ✅ Memoized service point component
const ServicePoint = memo(({ text }) => (
  <li>
    <img src={pointImg} alt="icon" className="point-icon" loading="lazy" />
    {text}
  </li>
));

const ServiceCorporate = () => {
  const servicePoints = [
    "Company/LLP/Partnership Formation",
    "Conversion of Firms to Companies",
    "Consultancy on Company Law Matters",
    "Mergers, Acquisitions & Corporate Restructuring",
    "Annual ROC/MCA Compliances",
    "RBI & FEMA Compliances",
    "Representation before Register of Companies",
    "Directors Report, Notice & Minutes",
    "Public/Bonus/Right Issue Advisory",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="services-hero corporate-hero"
        style={{
    backgroundImage: `url(${ corporateImg })`, // ✅ Use template literal with imported image
  }}>
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1 className="services-heading">Building Trust Through Transparency</h1>
          <p className="services-paragraph">
            We deliver through corporate governance & secretarial services that enhance credibility,
            accuracy, and confidence for your stakeholders.
          </p>
        </div>
      </div>

      {/* Corporate Center Section */}
      <div className="detail-section">
        <Container className="text-center">
          <div className="d-flex align-items-center justify-content-center flex-wrap">
            <img src={LineImg} alt="line-left" className="side-line" loading="lazy" />
            <div className="center-image-wrapper">
              <div className="corporate-image-text">
                Corporate Governance & Secretarial Practice
              </div>
            </div>
            <img src={LineImg} alt="line-right" className="side-line mirrored" loading="lazy" />
          </div>
        </Container>
      </div>

      {/* Service Points Section */}
      <div className="service-image-section">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <ul className="service-points">
                {servicePoints.map((point, index) => (
                  <ServicePoint key={index} text={point} />
                ))}
              </ul>
            </Col>

            <Col md={6} className="text-center text-md-end">
              <img
                src={CorporateRightImg}
                alt="Corporate Governance Detail"
                className="service-right-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default memo(ServiceCorporate);
